export default __webpack_public_path__ + "static/media/bb1.1.e08a3988.png";